import { reactive, toRef, isReactive, set } from "vue";
import { useNuxtApp } from "../nuxt.mjs";
export const useState = (key, init) => {
  const nuxtApp = useNuxtApp();
  if (!nuxtApp.payload.useState) {
    nuxtApp.payload.useState = {};
  }
  if (!isReactive(nuxtApp.payload.useState)) {
    nuxtApp.payload.useState = reactive(nuxtApp.payload.useState);
  }
  if (!(key in nuxtApp.payload.useState)) {
    set(nuxtApp.payload.useState, key, void 0);
  }
  const state = toRef(nuxtApp.payload.useState, key);
  if (state.value === void 0 && init) {
    state.value = init();
  }
  return state;
};
